@if (notification()) {
  <div class="amplifier">
    <cw-icon class="amplifier-icon" [icon]="iconsMap[notification().level]" size="sm" font="cortex" />
  </div>

  <div class="wrapper">
    <div class="header">
      @if (notification()?.messages?.card) {
        <div
          class="snack-title"
          [innerHTML]="notification().messages.card | translate: notification().translationParams | safeHtml"
        ></div>
      }

      <div class="hide-btn-wrapper">
        <cw-tooltip
          [content]="(!notification().hidden ? 'AlarmCenterHideBtnTooltip' : 'AlarmCenterShowBtnTooltip') | translate"
          placement="bottom"
        >
          <cw-action-icon
            class="hide-btn"
            [icon]="!notification().hidden ? 'visibility-off' : 'visibility-on'"
            font="cortex"
            (click)="$event.stopPropagation(); hide.emit()"
          />
        </cw-tooltip>
      </div>
    </div>

    <div class="footer">
      <div class="snack-badge">
        <ng-content select="[badge]" />
      </div>

      <div class="right">
        <div class="snack-text">{{ notification().patient | personName }}</div>
        @if (notification().timestamp) {
          <div class="snack-timestamp">{{ notification().timestamp | localizedDate: dateFormat.SHORT_TIME }}</div>
        }
      </div>
    </div>
  </div>
}
